export default __webpack_public_path__ + "static/media/Geary Higgins.1a372ea5.jpg";